import React, { useEffect, useState } from "react";
import classes from "./TopContentsTitle.module.scss";
import logo from "../../static/images/mokomoko-green.png";
import line from "../../static/images/dashed-line.png";

type Props = {
  image?: string;
  title?: string;
};

const TopContentsTitle = (props: Props) => {
  return (
    <>
      <div className={classes.container}>
        <div className={classes.block}>
          <img className={classes.logo} src={logo} alt={logo} />
          {props.title != null && (
            <span className={classes.title}>{props.title}</span>
          )}
          {props.image != null && (
            <img
              className={classes.titleImage}
              src={props.image}
              alt={props.image}
            />
          )}
        </div>
        <img src={line} alt={line} />
      </div>
    </>
  );
};

export default TopContentsTitle;
